import React from "react";

import { Dialog, DialogContent, DialogTitle } from "@/app/components/ui/dialog";
import type { ResumeDraft } from "@/app/types/resume";

import ResumeUntyped from "../Review/Resume";

// The frozen Resume renderer is untyped JSX; only `resumeData` is required here.
const Resume = ResumeUntyped as unknown as React.ComponentType<{ resumeData: ResumeDraft }>;

interface ResumePreviewModalProps {
	resumeData: ResumeDraft;
	/**
	 * Controlled mode (resume builder): pass `open` + `onOpenChange` to render a
	 * shadcn Dialog. Legacy mode (Bootstrap pages, e.g. MyResumes): omit both and
	 * the old jQuery-driven `#ResumePreview` markup renders instead.
	 */
	open?: boolean;
	onOpenChange?: (open: boolean) => void;
}

function ResumePreviewModal({ resumeData, open, onOpenChange }: ResumePreviewModalProps) {
	if (open === undefined) {
		// Legacy Bootstrap chrome, activated by data-toggle triggers on pages that
		// still load Bootstrap JS (outside the builder routes). Do not use in the
		// resume builder.
		return (
			<div className="modal fade" id="ResumePreview" tabIndex={-1} role="dialog" aria-hidden="true">
				<div className="modal-dialog" role="document">
					<div className="modal-content border-0">
						<div className="modal-body pb-5 resume-preview relative rounded-md">
							<button
								type="button"
								className="close absolute top-4 right-4 text-dark z-100"
								data-dismiss="modal"
								aria-label="Close"
							>
								<i className="fas fa-times" />
							</button>
							<Resume resumeData={resumeData} />
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="block max-h-[95vh] w-[900px] max-w-[90vw] gap-0 overflow-hidden p-0 sm:max-w-[90vw]">
				<DialogTitle className="sr-only">Resume preview</DialogTitle>
				<div className="max-h-[95vh] overflow-y-auto">
					<Resume resumeData={resumeData} />
				</div>
			</DialogContent>
		</Dialog>
	);
}

export default ResumePreviewModal;
